import i18next from 'i18next';

i18next.addResources('es', 'stats-summary', {
  title: 'Resumen de proyectos y acciones',
  totalActions: 'Cantidad',
  estimatedInvestment: 'Inversión estimada (USD millones)'
});

i18next.addResources('en', 'stats-summary', {
  title: 'Projects and actions summary',
  totalActions: 'Count',
  estimatedInvestment: 'Estimated investment (USD millions)'
});

i18next.addResources('pt', 'stats-summary', {
  title: 'Resumo dos projetos e ações',
  totalActions: 'Quantidade',
  estimatedInvestment: 'Investimento estimado (USD milhões)'
});
